import React, { useCallback, useEffect, useState } from "react";
import styled, { withTheme } from "styled-components";
import { AUDIT_TRAIL_MAX_LENGTH_FILTER_INPUT } from "../../../../modules/constants";
import PrimaryButton from "../../../ui-library/Buttons/PrimaryButton/PrimaryButton";
import CustomPopover from "../../../ui-library/CustomPopover/CustomPopover";
import LabelledInput from "../../../ui-library/LabelledInput/LabelledInput";

const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const FormActionButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-top: 20px;
`;

const ResourceFilterForm = (props) => {
  const {
    show,
    onClose,
    onSubmit,
    currentFilterResource,
    target,
    containerRef,
  } = props;

  const [filterResource, setFilterResource] = useState("");

  useEffect(() => {
    setFilterResource(currentFilterResource ?? "");
  }, [currentFilterResource]);

  const handleOnClose = useCallback(() => {
    onClose();
    setFilterResource(currentFilterResource ?? "");
  }, [onClose, currentFilterResource]);

  const onKeyDown = (event) => {
    if (event.key === "Enter") {
      onSubmit(filterResource);
    }
  };

  return (
    <CustomPopover
      show={show}
      target={target}
      container={containerRef}
      onClose={handleOnClose}
      title="Filter by"
    >
      <FormContainer data-testid="resource-filter-form">
        <LabelledInput
          title="Object ID"
          value={filterResource}
          type="text"
          autoFocus={true}
          onChange={(e) =>
            e.target.value.length <= AUDIT_TRAIL_MAX_LENGTH_FILTER_INPUT &&
            setFilterResource(e.target.value)
          }
          data-testid="atf-resource-input"
          onKeyDown={onKeyDown}
        />
        <FormActionButtonsContainer>
          <PrimaryButton
            data-testid="resource-filter-modal-submit-button"
            size="sm"
            onClick={() => {
              onSubmit(filterResource);
            }}
          >
            Apply
          </PrimaryButton>
        </FormActionButtonsContainer>
      </FormContainer>
    </CustomPopover>
  );
};

export default withTheme(ResourceFilterForm);
